import { RouteRecordRaw } from 'vue-router'

const RestockPlatformRouter: Array<RouteRecordRaw> = [
  { 
    path: '/KiliMall/restockReplenishment/replenishmentList', 
    name: '补货计划主页', 
    component: () => import('@/views/Kilimall/manage/restockReplenishment/replenishmentList.vue')
  },
  { 
    path: '/KiliMall/restockReplenishment/checked', 
    name: '补货计划已审核', 
    component: () => import('@/views/Kilimall/manage/restockReplenishment/checkedReplenishment.vue')
  },
  { 
    path: '/KiliMall/restockReplenishment/closed', 
    name: '补货计划已关闭', 
    component: () => import('@/views/Kilimall/manage/restockReplenishment/checkedReplenishment.vue')
  },
  { 
    path: '/KiliMall/restockReplenishment/create', 
    name: '创建编辑补货计划', 
    component: () => import('@/views/Kilimall/manage/restockReplenishment/addReplenishment.vue')
  },
  { 
    path: '/KiliMall/restockReplenishment/proposalView', 
    name: '计划行信息详情', 
    component: () => import('@/views/Kilimall/manage/restockReplenishment/proposalQtyView.vue')
  },
  { 
    path: '/KiliMall/restockReplenishment/pendingReplenishment', 
    name: '平台待审核补货计划', 
    component: () => import('@/views/Kilimall/manage/restockReplenishment/pendingReplenishment.vue')
  },
]
export default RestockPlatformRouter
